import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';

export interface NestedMenuItemMobileProps {
    parentMenuOpen: boolean;
    label?: React.ReactNode;
    divider?: boolean;
}

const NestedMenuItemMobile = React.forwardRef<HTMLLIElement | null, NestedMenuItemMobileProps>(
    function NestedMenuItemMobile(props, ref) {
        const { parentMenuOpen, label, children, divider } = props;

        const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

        const open = isSubMenuOpen && parentMenuOpen;

        const iconStyle: React.CSSProperties = { position: 'absolute', right: '5px', top: '37%' };

        return (
            <>
                <MenuItem
                    ref={ref}
                    onClick={() => setIsSubMenuOpen(!isSubMenuOpen)}
                    sx={{
                        position: 'relative',
                    }}
                    divider={divider}
                >
                    <div style={iconStyle}>
                        {open ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
                    </div>
                    {label}
                </MenuItem>
                <Collapse in={open} timeout='auto' unmountOnExit>
                    <div
                        style={{
                            paddingLeft: 16,
                        }}
                    >
                        {children}
                    </div>
                </Collapse>
            </>
        );
    }
);

export default NestedMenuItemMobile;
